import styled from "styled-components";

export const LogoWrapper = styled.div`
  width: 74px;
  margin-top: -18px;

  img {
    width: 100%;
  }
`;

export const LogoItem = styled.div`
  font-size: 0;

  svg {
    height: 40px;
    width: auto;
  }
`;
